export interface Picking {
  id: number
  sku: string
  ean13: string
  name: string
  ERPCode: string
  realHeight?: number
  realWidth?: number
  realLength?: number
  realWeight?: number
  shippingHeight?: number
  shippingWidth?: number
  shippingLength?: number
  shippingWeight?: number
  image?: PickingImage[]
  active: boolean
}

export interface PickingGrid {
  id: number
  sku: string
  ean13: string
  name: string
  ERPCode: string
  realHeight?: number
  realWidth?: number
  realLength?: number
  realWeight?: number
  shippingHeight?: number
  shippingWidth?: number
  shippingLength?: number
  shippingWeight?: number
  image?: PickingImage[]
  active: boolean
}

export interface PickingProduct {
  id: number
  sku: string
  ean13: string
  name: string
  ERPCode: string
  realHeight?: number
  realWidth?: number
  realLength?: number
  realWeight?: number
  shippingHeight?: number
  shippingWidth?: number
  shippingLength?: number
  shippingWeight?: number
  active: boolean
}

export interface IBusquedaPicking {
  sku: string
  ean13: string
  ERPCode: string
}

export interface PickingImage {
  stockKeepingUnitImageId: number
  name: string
  url: string
  position: number
  active: boolean
  stockKeepingUnitId: number
}

export interface PickingDetail {
  position: string
  sku: string
  qty: number
  batch: string
  ean13: string
  expirationDate?: string
  productName?: string
}

export class PickingRoute {
  public pickingRouteId: number = 0
  public pickingRouteStateId: number = 0
  public pickingRouteState: string = ''
  public createdAt: Date | null = null
  public startedAt: Date | null = null
  public endedAt: Date | null = null
  public zoneId: number = 0
  public zone: string = ''
  public countProducts: number = 0
  public pickedProducts: number = 0
  public workOrders: any = []
  public zoneName: string = ''
  public lpn: string | undefined = ''
  public typePickingRouteId: number = 0
  public scanPositionOnPicking: boolean = false
  public mandatoryLPNOnPicking: boolean = false
  public autoAssignPackingPosition: boolean = false
}

export class PickingRouteDetails {
  public pickingRouteDetailId: number = 0
  public pickingRouteId: number = 0
  public workOrderDetailId: number = 0
  public positionId: number = 0
  public realQuantity: number = 0
  public pickedQuantity: number = 0
  public sku: number = 0
  public product?: StockKeepingUnit = undefined
  public workOrders: any = []
  public position?: Position = undefined
  public resumen: Resumen = new Resumen()
  public isInRecall: boolean = false
  public id: string = ''
}

export class Resumen {
  public countProducts: number = 0
  public pickedProducts: number = 0
  public pickedQty: number = 0
  public pickingRouteId: number = 0
  public realQty: number = 0
  public startedAt: string = ''
  public zoneId: number = 0
  public zoneName: string = ''
  public lpn: string | undefined = ''
  public typePickingRouteId: number = 0
  public scanPositionOnPicking: boolean = false
  public mandatoryLPNOnPicking: boolean = false
  public autoAssignPackingPosition: boolean = false
}

export class Position {
  public positionId: number = 0
  public positionCode: string = ''
  public positionName: string = ''
}

export class StockKeepingUnit {
  skuId: number = 0
  sku: string = ''
  dunQty: number | undefined = undefined
  ean13: string = ''
  erpCode: string = ''
  name: string = ''
  urlImagen: string = ''
  batchNumber: string | undefined = undefined
  expirationDate: Date | undefined = undefined
  batchId: number | undefined = undefined
}

export class PickingPageState {
  public pickingRoute?: PickingRoute = undefined
  public pickingRouteDetails?: PickingRouteDetails = undefined
  public openSnackbar: boolean = false
  public messageColor: string = ''
  public messageStatus: string = ''
  public isLoading: boolean = false
  public isPicking: boolean = false
}

export class PickingInputData {
  public sku: string = ''
  public quantity: number = 0
  public positionName: string = ''
}

export class UserWms {
  public userId: number = 0
  public userName: string = ''
  public email: string = ''
  public profileId: number = 0
  public contactNumber: string = ''
  public active: boolean = true
  public lastUpdate: Date = new Date()
  public positionId: number = 0
  public userAlias: string = ''
}

export class PickingRouteNextPositionDto {
  public pickingRouteId: number = 0
  public userId: number = 0
  public listSkippedProducts: number[] = []
  public listPositionsNoStock: number[] = []
}

export class PickingRouteMovementDto {
  public skuId: number = 0
  public quantityPicked: number = 0
  public pickingRouteId: number = 0
  public positionId: number = 0
  public userId: number = 0
  public batchId: number | undefined = undefined
}

export interface PickingRouteLocalStorage {
  pickingRouteId: number | undefined
  listSkippedProducts: number[] | null
  listPositionsNoStock: string[] | null
}

export interface PickingGetRouteDetail {
  pickingRouteId: number
  userId: number
  startDate: string
  totalSku: number
  realQty: number
  pickedQty: number
  workOrderId: number[]
  pickingRouteDetailMovement: pickingRouteDetailMovement[]
  packingPositions: Position[]
  relatedRouteIds: number[]
  courierName?: string
  courierServiceName?: string
  orderReferenceId?: number
}

export interface pickingRouteDetailMovement {
  qtyPicked: number
  positionId: number
  positionName: string
  sku: string
  batch: string
  ean13: string
  expirationDate?: string
  productName?: string
}

export interface EmptyPickingRouteRequestDto {
  pickingRouteId: number
  userId: number
  positionName: string
}

export class PickingMessageView {
  public title: string = ''
  public message: string = ''
  public nextStep: number = 0
}

export interface PickingValidateHeader {
  pageSize: number
  pickedQty: number
  pickingRouteId: number
  realQty: number
  skuDetail: PickingValidateSkuDetail[]
  totalPage: number
  totalSku: number
  validationFinished: boolean
  workOrderIdList: number[]
  courierDeliveredDate: Date
  picker: string
  zoneName: string
  orderCancellationRequest: boolean
  allowToValidate: boolean
  typePickingRouteId: number
  lpn: string
  validationendedAt: Date
  validationUser: string
  hasVasRuleItems: boolean
  productOriginId?: number | null
  validateRouteWithoutProductScanning: boolean
  printCourierLabel: boolean
  printInternalLabel: boolean
}

export interface PickingValidateBatch {
  batchId: number
  batchNumber: string
  expirationDate: string
  pickedQty: number
}

export interface PickingValidateSkuDetail {
  id: number
  pickingRouteId: number
  pickingRouteDetailId: number
  skuId: number
  pickedQty: number
  realQty: number
  validatedQty: number
  sku: string
  eaN13: string
  name: string
  urlImage: string
  commentary: number
  excessQty: number
  validated: boolean
  isInRecall: boolean
  referenceId: string
  batches: PickingValidateBatch[]
  hasVasRule: boolean
}

export interface PickingValidateState {
  skuId: string
  pickingRouteId: number
  mensaje: string
  tipoMensaje: string
  switchSnackBar: boolean
  switchModal: boolean
  rows: PickingValidateSkuDetail[] | undefined
  showModalReportDiff: boolean
  isLoadingGrid: boolean
  btnFilter: string
  isLoadingPrint: boolean
  pickingValidatePDF: string
  page: number
  rowsPerPage: number
  totalItems: number
  isLoadingButton: boolean
  showAlert: boolean
}

export class SaveDifferencesPositionDto {
  public positionId: number = 0
  public pickedAdjustmentQty: number = 0
  public differenceQty: number = 0
  public reductionQty: number = 0
  public reservedQty: number = 0
  public commercialRejectionQty: number = 0
  public batchId?: number = undefined
}

export class SaveDifferencesDto {
  public skuId: number = 0
  public userId: number = 0
  public pickingRouteId: number = 0
  public pickingRouteDetailId: number = 0
  public differences: SaveDifferencesPositionDto[] = []
}

export interface UserZone {
  zoneId: number
  zoneName: string
  warehouseId: number
  warehouseName: string
}

export interface StartPickingRoute {
  userId: number
  typeRouteId: number
  zoneId: number
}

export interface SelectedZone {
  selectedZoneId: number
  userId: number
}
